import React from 'react'
import { UploadClaimForm } from '../../components/client/UploadClaimForm'
export const UploadClaim = () => {
    return (
        <>
            <UploadClaimForm/>

        </>)
} 